<template>
  <div class="row">
    <div class="col-lg-12 col-xl-12 mb-5">
      <dashboard-box :title="$t('campaigns.campaign_confirm')">
        <template v-slot:toolbar>
          Kampanya devam etmektedir.
        </template>
        <template v-slot:preview>
          <div class="row">
            <div class="col-md-3">
              <div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Toplam Mesaj</span>
                  <a class="text-muted text-hover-primary">1711</a>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Onaylı</span>
                  <span class="text-muted">69</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Reddedilen</span>
                  <span class="text-muted">2</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Onay Bekleyen</span>
                  <span class="text-muted">1640</span>
                </div>
              </div>
            </div>
            <div class="col-md-3"  style="border-left: 1px solid #e5e5e5">
              <div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Tekil Katılım</span>
                  <a class="text-muted text-hover-primary">1711</a>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Tekil Onaylı Katılım</span>
                  <span class="text-muted">69</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Puan Yüklenmiş Mesaj</span>
                  <span class="text-muted">0</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Yüklenmiş Puan</span>
                  <span class="text-muted">0</span>
                </div>
              </div>
            </div>
            <div class="col-md-6" style="border-left: 1px solid #e5e5e5">
              <div class="row">

                <div class="col-md-12">
                  <div>
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <span class="font-weight-bold mr-2">Reddedilen ve Email Gönderilmeyen Mesaj Sayısı</span>
                      <a class="text-muted text-hover-primary"><b-badge class="mr-1" variant="danger">2</b-badge></a>
                    </div>
                  </div>
                </div>
                <div class="col-md-12"  style="border-top: 1px solid #e5e5e5">
                  <b-form-group label="Member ID" class="mt-5" size="sm">
                    <b-input-group size="sm">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="text"
                          value=""
                      ></b-form-input>
                      <b-input-group-append>
                        <button v-on:click="loadPoint" class="btn btn-danger font-weight-bold text-uppercase ">RED EMAİLİ GÖNDER</button>
                      </b-input-group-append>
                    </b-input-group>

                  </b-form-group>

                </div>
                <div class="col-md-3">

                </div>
              </div>
            </div>
            <div class="col-md-12 pt-3 pb-3" style="border-top: 1px solid #e5e5e5">
              <div class="row">
                <div class="col-md-6">
                  <div class="mt-3">
                    <b-button-group size="sm">
                      <b-button variant="primary">Hepsini Seç</b-button>
                      <b-button>Hepsi</b-button>
                      <b-button variant="warning">Onay Bekleyenler</b-button>
                      <b-button variant="success">Onaylananlar</b-button>
                      <b-button variant="danger">Reddedilenler</b-button>
                    </b-button-group>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mt-3">
                    <b-button-group size="sm" class="fa-pull-right">
                      <b-button variant="success">Seçili Olanları Onayla</b-button>
                      <b-button variant="danger">Seçili Olanları Reddet</b-button>
                    </b-button-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <data-table
              :items="table.items"
              :fields="report.fields"
              :paginate="report.paginate"
              page.sync="3"
              perPage.sync="10"
          ></data-table>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>



<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";

export default {
  name: "ConfirmMessageShareCampaign",
  components: { DataTable, DashboardBox },
  methods: {
    loadPoint(){
      Swal.fire({
        title: "",
        text: "Puanlar başarıyla yüklendi!",
        icon: "success",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText : "Tamam",
      });
    },
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.name = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  data() {
    return {
      form : {

      },
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'checkbox', label: 'Seç', sortable: true},
          {key: 'id', label: '#', sortable: true},
          {key: 'name', label: 'Adı', sortable: true},
          {key: 'surname', label: 'Soyadı', sortable: true},
          {key: 'email', label: 'E-Posta', sortable: true},
          {key: 'register_date', label: 'Katılım Tarihi', sortable: true},
          {key: 'user_image', label: 'Resim', sortable: true},
          {key: 'message', label: 'Mesaj', sortable: false},
          {key: 'gsm', label: 'GSM', sortable: true},
          {key: 'status_id', label: 'Üye Durumu', sortable: true},
          {key: 'email_status', label: 'E-Posta Durumu', sortable: true},
        ],
      },
      table : {
        items : [
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'message' : '#yaziseviyorumçünkü bol bol yüzmeye fırsat bulabiliyorum.' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'message' : '#yaziseviyorumçünkü bol bol yüzmeye fırsat bulabiliyorum.' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'message' : '#yaziseviyorumçünkü bol bol yüzmeye fırsat bulabiliyorum.' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'message' : '#yaziseviyorumçünkü bol bol yüzmeye fırsat bulabiliyorum.' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'message' : '#yaziseviyorumçünkü bol bol yüzmeye fırsat bulabiliyorum.' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'message' : '#yaziseviyorumçünkü bol bol yüzmeye fırsat bulabiliyorum.' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'message' : '#yaziseviyorumçünkü bol bol yüzmeye fırsat bulabiliyorum.' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'message' : '#yaziseviyorumçünkü bol bol yüzmeye fırsat bulabiliyorum.' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'message' : '#yaziseviyorumçünkü bol bol yüzmeye fırsat bulabiliyorum.' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'message' : '#yaziseviyorumçünkü bol bol yüzmeye fırsat bulabiliyorum.' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'message' : '#yaziseviyorumçünkü bol bol yüzmeye fırsat bulabiliyorum.' },
        ],
      },
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('offers.offers'), route: "offers" },
      { title: this.$t('campaigns.campaign_confirm') }
    ]);
  },
  computed: {
    picture() {
      return process.env.BASE_URL + "media/users/300_21.jpg";
    }
  }
}
</script>

<style scoped>
</style>
